import { forwardRef, type ReactElement, useImperativeHandle } from "react";

import type {
  ICellRendererParams,
  IDetailCellRendererParams
} from "ag-grid-enterprise";

import "./typedAgGridMasterDetail.scss";

export const DetailCellRenderer = forwardRef(
  (
    { data }: IDetailCellRendererParams<{ subComponent: ReactElement }>,
    ref
  ) => {
    useImperativeHandle(ref, () => {
      return {
        // Return true to tell AG Grid to ignore default destruction/refresh
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        refresh(_params: ICellRendererParams<{ subComponent: ReactElement }>) {
          //  Change detected, but suppression/custom logic handled it.
          return false;
        }
      };
    });

    return (
      <section className={"grid-detail-cell-renderer"}>
        <div className={"grid-detail-cell-subcomponent"}>
          {data?.subComponent}
        </div>
      </section>
    );
  }
);
